@if (authService.isAuthLoading()) {
    <si-loading-spinner
        [isBlockingSpinner]="true"
        [isSpinnerOverlay]="true"
        [ariaLabel]="'management.loading' | translate"
    />
}

@if (isRouterPathUnauthorized() || isRouterPathNotFound()) {
    <div class="h-screen">
        <router-outlet />
        <tran-notification-outlet />
    </div>
} @else {
    <div class="has-navbar-fixed-top si-layout-fixed-height h-100 flex min-h-screen flex-col">
        <si-application-header>
            <si-header-brand>
                <a siHeaderLogo routerLink="/" class="d-none d-md-flex"></a>
                <h1 class="application-name">{{ 'management.header.applicationName' | translate }}</h1>
            </si-header-brand>

            <si-header-actions class="flex items-center !gap-4">
                <a
                    [href]="transformationsFondsWebsiteLink"
                    target="_blank"
                    class="text-base text-[var(--element-ui-0)] hidden md:block"
                >
                    {{ 'management.header.websiteLink' | translate }}
                    <i aria-hidden="true" class="link-icon link-end element-export flip-rtl"></i>
                </a>
                @if (userDetails) {
                    <tran-user-avatar class="p-2" [userDetails]="userDetails" showOnlyAvatar />
                }
            </si-header-actions>
        </si-application-header>

        <si-navbar-vertical
            navbarCollapseButtonText="collapse"
            navbarExpandButtonText="expand"
            [items]="navbarVerticalItems"
        >
            <div class="flex flex-1 flex-col px-4" id="main-content">
                <div class="flex-1">
                    <router-outlet />
                    <tran-notification-outlet />
                </div>
                <si-footer [copyright]="footerCopyright" [links]="footerItems" />
            </div>
        </si-navbar-vertical>
    </div>
}
